import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Tariff_Interface, Tariff_Interface } from 'src/app/Interface/Tariff_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceService } from 'src/app/Service/Device/Device.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PriceService } from 'src/app/Service/Price/Price.service';
import { TariffService } from 'src/app/Service/Tariff/Tariff.service';

@Component({
  selector: 'app-TariffEdit',
  templateUrl: './TariffEdit.component.html',
  styleUrls: ['./TariffEdit.component.scss']
})
export class TariffEditComponent implements OnInit {

  tariff_Alpha:String=""
  tariff_expert_Alpha:String=""
  EditRecord:Number
  Selected_Price_Record:Tariff_Interface=Empty_Tariff_Interface();

  constructor(
    private Tariff_Service:TariffService,
    private Nav_Service:NavService,
    private Device_Service:DeviceService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService,
    private route: ActivatedRoute,
    private Price_Service:PriceService,
  ) { }

  ngOnInit() {

    this.EditTariff=new FormGroup({
      id :new FormControl(),
      Dsc:new FormControl(null,Validators.required),
    })

    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))

    this.Nav_Service.CheckValidPage(49).subscribe(
      data=>{
        this.Tariff_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.get_Form_Dsc().setValue(data.dsc)
            
            this.Selected_Price_Record=data
            this.Tariff_Change()
            this.Tariff_Expert_Change()
          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }


  //#region  Form Add

  EditTariff:FormGroup;

  get_Form_Dsc(){
    return this.EditTariff.get('Dsc') as FormControl;
  }

  //#endregion

  InProccessing:boolean=false

  SubmitEditTariff(){
    var Record:Tariff_Interface =Empty_Tariff_Interface()
    Record.id=this.Selected_Price_Record.id
    Record.dsc=this.get_Form_Dsc().value
    this.InProccessing=true
    this.Tariff_Service.EditTariff(Record).subscribe(
      data=>{
        this.InProccessing=false
        if(data.id==-2){
          this.Alertify_Service.ErrorMessage("توضیحات وارد شده ، در لیست وجود دارد")
        }
        else{
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Tariff_Change(){
    this.Price_Service.GetPriceAlphabet(this.Selected_Price_Record.tariff+"").subscribe(
      data=>{
        this.tariff_Alpha=data['price']
      }
    )
  }

  Tariff_Expert_Change(){
    this.Price_Service.GetPriceAlphabet(this.Selected_Price_Record.tariff_expert+"").subscribe(
      data=>{
        this.tariff_expert_Alpha=data['price']
      }
    )
  }

}
